import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles((theme) => ({
  tabContent: {
    flexGrow: 1,
    flexBasis: 0,
    flexShrink: 1,
    padding: `${theme.sizes.base / 2}px`,
    userSelect: 'none',
  },
}));

export default useStyle;
